import { render, staticRenderFns } from "./Skeleton.vue?vue&type=template&id=038b47d3&scoped=true&"
import script from "./Skeleton.vue?vue&type=script&lang=js&"
export * from "./Skeleton.vue?vue&type=script&lang=js&"
import style0 from "./Skeleton.vue?vue&type=style&index=0&id=038b47d3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038b47d3",
  null
  
)

export default component.exports